import {NgModule} from '@angular/core';
import {IfOnDomDirective} from './if-on-dom/if-on-dom.directive';
import {ScrollbarDirective} from './scrollbar/scrollbar.directive';
import {CanAccessDirective} from './can-access/can-access.directive';
import {NavbarToggleDirective} from '../comp/navigation/navbar-toggle.directive';
import {UrlPrefixDirective} from './url-prefix/url-prefix.directive';
import { ExpirationTimeStyleDirective } from './expiration-time-style/expiration-time-style.directive';
import {PlaceholderDirective} from '@app/core/directives/placeholder/placeholder.directive';
import {ClickStopPropagation} from '@app/core/directives/click-stop-propagation/click-stop-propagation';
import {DynamicTemplateDirective} from '@app/core/directives/dynamic-template/dynaminc-template.dirictive';
import { OnlyNumberDirective } from './only-number/only-number.directive';
import {AutofocusDirective} from '@app/core/directives/autofocus/autofocus.directive';

@NgModule({
    declarations   : [
        IfOnDomDirective,
        ScrollbarDirective,
        CanAccessDirective,
        NavbarToggleDirective,
        UrlPrefixDirective,
        ExpirationTimeStyleDirective,
        PlaceholderDirective,
        ClickStopPropagation,
        DynamicTemplateDirective,
        OnlyNumberDirective,
        AutofocusDirective
    ],
    exports        : [
        IfOnDomDirective,
        ScrollbarDirective,
        CanAccessDirective,
        NavbarToggleDirective,
        UrlPrefixDirective,
        ExpirationTimeStyleDirective,
        PlaceholderDirective,
        ClickStopPropagation,
        DynamicTemplateDirective,
        OnlyNumberDirective,
        AutofocusDirective
    ]
})

export class DirectivesModule {

}
